import { Link } from 'react-router-dom';

export function NotFoundPage(): React.JSX.Element {
  return (
    <div className="flex min-h-full items-center justify-center px-6 py-24">
      <div className="text-center">
        <h1 className="text-2xl font-semibold tracking-tight text-fg">Page not found</h1>
        <p className="mt-2 text-sm text-fg-muted">
          That page does not exist, or you do not have access to it.
        </p>
        <Link to="/" className="mt-6 inline-block text-sm font-medium text-fg underline">
          Back to your dashboard
        </Link>
      </div>
    </div>
  );
}
